import { Component } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent {


  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = true
  }

  ngOnInit(): void {

  }


}
